<div class="mango-aws-s3-upload" style="padding: 5px;">
  <div class="header-upload">
    <div class="title-upload">
      <!-- <span>Upload Files</span> -->
      <label for="file-upload-{{ token }}" class="choose-add">
        <a class="btn btn-sm btn-primary desktop-collection">
          <i class="fa fa-plus-circle"></i>
          Upload Files
        </a>
      </label>
      <input id="file-upload-{{ token }}" type="file" multiple (change)="onSelectFile($event)" style="display: none;"/>
    </div>

    <!-- <mango-list-view [selected]="selectedListView" (onSelected)="onSelectedHandle($event)"></mango-list-view> -->
  </div>

  <div class="mng-drap-drop-folder" [ngClass]="{'uploading': pending > 0}">
    <ngx-file-drop dropZoneLabel="Drag and drop files od folders"
                   (onFileDrop)="dropped($event)"
                   (onFileOver)="fileOver($event)"
                   (onFileLeave)="fileLeave($event)">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">

<!--        <div class="upload-hint text-center" *ngIf="!files.length">-->

<!--          <div><i class="fa fa-camera" aria-hidden="true"></i></div>-->
<!--          <div>-->
<!--            <small class="title-hint text-danger alert alert-danger" *ngIf="acceptedFilesType.length">-->
<!--              Allowed Files:-->
<!--              <strong *ngFor="let typeFile of acceptedFilesType; let i = index">-->
<!--                {{ typeFile }} <span *ngIf="acceptedFilesType.length - 1 !== i">|</span>-->
<!--              </strong>-->
<!--            </small>-->
<!--          </div>-->

<!--          <div><span class="title-hint">Drag and drop files and folders here</span></div>-->
<!--          <div class="title-hint">or choose</div>-->
<!--          <label for="file-upload-{{ token }}" class="choose-add">Add file</label> or-->
<!--          <label for="folder-upload-{{ token }}" class="choose-add">Add folders.</label>-->

<!--          &lt;!&ndash; choose select file &ndash;&gt;-->
<!--          <input id="file-upload-{{ token }}" type="file" multiple (change)="onSelectFile($event)"-->
<!--                 style="display: none;"/>-->

<!--          &lt;!&ndash; choose select folder &ndash;&gt;-->
<!--          <input id="folder-upload-{{ token }}" type="file" multiple webkitDirectory (change)="onSelectFile($event)"-->
<!--                 style="display: none;"/>-->
<!--        </div>-->

        <div class="upload-hint text-center"
             *ngIf="files.length && !listSingleFilesPaginateUI.length && !listFilesFolderUI.length">
          <div><i class="fas fa-circle-notch fa-spin"></i></div>
          <div><span class="title-hint">processing data</span></div>
        </div>

        <!-- CONTENT ============================================================= -->

        <div class="file-list">
          <!--        <div class="file-list">-->

            <div *ngIf="showUploader && listSingleFilesPaginateUI.length">

              <div class="wrapper-grid" [ngClass]="{'inline-wrapper': selectedListView === 'list'}">

                <div *ngIf="selectedListView === 'list'" class="nav-bar">
                  <nav class="navbar">
                    <div class="menus">
                      <span>{{ completed }} uploads complete</span>
                    </div>
                    <div class="toggler">
                      <button type="button" class="close" aria-label="Close" (click)="btnCloseUploader()">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </nav>
                </div>

                <div class="progress-list">
                  <ng-container *ngFor="let item of listFilesFolderUI; let i = index">
                    <div class="item-data" [ngClass]="{'inline-item': selectedListView === 'list'}">
                      <mango-folder-upload
                        [data]="item"
                        [listView]="selectedListView"
                        [showMoreLimit]="showMoreLimit"
                      ></mango-folder-upload>
                    </div>
                  </ng-container>

                  <ng-container *ngFor="let item of listSingleFilesPaginateUI; let i = index">
                    <div class="item-data" [ngClass]="{'inline-item': selectedListView === 'list'}" *ngIf="item.type !== 'mng-compressed'">
                      <mango-item-upload
                        [data]="item"
                        [listView]="selectedListView"
                      ></mango-item-upload>
                    </div>
                  </ng-container>
                </div>

                <!--            <div class="item-more" [ngClass]="{'inline-item': selectedListView === 'list'}"-->
                <!--                 *ngIf="hasCompressed"-->
                <!--                 (click)="btnShowCompressedFiles()">-->
                <!--              <span>More ...</span>-->
                <!--            </div>-->

                <!--            <ng-container *ngFor="let item of listSingleFilesCompressedUI; let i = index">-->
                <!--              <div [ngClass]="{'inline-item': selectedListView === 'list'}">-->
                <!--                <mango-item-upload-->
                <!--                  [data]="item"-->
                <!--                  [listView]="selectedListView"-->
                <!--                ></mango-item-upload>-->
                <!--              </div>-->
                <!--            </ng-container>-->

              </div>
        </div>

          <ng-content></ng-content>
        </div>
      </ng-template>
    </ngx-file-drop>

    <!-- <div class="show-more"
         *ngIf="showMoreLimit && this.listSingleFilesUI.length && this.listSingleFilesUI.length > this.showMoreLimit">
      <button class="btn btn-primary btn-sm btn-block" (click)="btnShowMore()">Show More ...</button>
    </div> -->

    <div class="bottom-messages">
      <small *ngIf="isCompressing">
        Compress some files to upload
        <i class="fas fa-circle-notch fa-spin"></i>
      </small>
    </div>
  </div>

  <div class="global-progress" *ngIf="total > 0">
    <div class="progress">
      <div class="progress-bar bg-success" role="progressbar" [style.width]="stacked[0].value + '%'" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
      <div class="progress-bar bg-warning" role="progressbar" [style.width]="stacked[1].value + '%'" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
      <div class="progress-bar bg-danger" role="progressbar" [style.width]="stacked[2].value + '%'" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
    <!-- <progressbar class="progress" [value]="stacked" [max]="100"></progressbar> -->

    <div>
      <span class="completed">
        <i class="fas fa-stop"></i>
        Completed ({{ completed }})
      </span>

      <!--      <span class="updating">-->
      <!--        <i class="fas fa-stop"></i>-->
      <!--        Updating (20)-->
      <!--      </span>-->

      <!--      <span class="processing">-->
      <!--        <i class="fas fa-stop"></i>-->
      <!--        Processing (20)-->
      <!--      </span>-->

      <span class="processing">
        <i class="fas fa-stop"></i>
        Pending ({{ pending }})
      </span>

      <span class="failed">
        <i class="fas fa-stop"></i>
        Failed (0)
      </span>
    </div>
  </div>

</div>
<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.14.0/css/all.min.css" rel="stylesheet">
